/* CSS */
import "../bootstrap/css";

/* loading & showing loading */
import loading, { showLoading, hideLoading } from "../bootstrap/loading";

/* config and my-assets */
import { TimeOut, AppInfo } from "../configs/base";
import vi from "../public/vi.json";

/* 3rd-utils */
import { createI18n } from "vue-i18n";
import { locale, loadMessages } from "devextreme/localization";
import mitt from "mitt";

/* my-helpers */
import $Core from "../bootstrap/$Core";
import Helper from "./utils/Helper";

/* app-logic */
import vuex from "./vuex";
import createRouter from "./router";

/* vue3-utils */
import { createStore } from "vuex";
import { createApp } from "vue";

// Moment
import moment from "moment";
//plugin
import moneyFormat from "./utils/money-format";

import App from './App.vue'
// import routerIonic from './router';

/* define 3rd-utils */
const $i18n = createI18n({
    locale: "string",
    fallbackLocale: "en",
    globalInjection: true,
    messages: {
        string: require("../public/string.json")
    }
});
const emitter = mitt();

/* define my-utils */
const $Helper = new Helper($Core);

const store = createStore(vuex);
store.$Core = $Core;
store.$Helper = $Helper;
store.$loading = loading;
store.$i18n = $i18n;

/* debug */
window.$Core = $Core;
window.$store = store;
window.$Helper = $Helper;
window.$loading = loading;
window.$emitter = emitter;
window.$i18n = $i18n;
window.$MoneyFormat = moneyFormat;
window.$router = createRouter($Core);

/* main-handler */
(async function SonPhatNumberOne(app) {
    // console.log("READY", await $Core.AuthApi.Ready());

    const router = createRouter($Core);

    app.config.globalProperties.$appInfo = AppInfo;
    app.config.globalProperties.emitter = emitter;
    app.config.globalProperties.moment = moment;
    app.use(router);
    app.use($i18n);
    app.use(moneyFormat);
    app.use({
        install(app) {
            let prototype = app.config.globalProperties;
            function protoDefProp(propName, getter, setter) {
                let propMap = {};
                getter && (propMap.get = getter);
                setter && (propMap.get = setter);
                Object.defineProperty(prototype, propName, propMap);
            }

            protoDefProp("$startLoading", () => {
                showLoading();
                // setTimeout(() => {
                //     hideLoading();
                // }, TimeOut);
                return true;
            });
            protoDefProp("$stopLoading", () => (hideLoading(), true));
            protoDefProp("$Core", () => $Core);
            protoDefProp("$Helper", () => $Helper);
            protoDefProp("$Nope");
            protoDefProp("$MoneyFormat", () => moneyFormat);
        }
    });

    app.use(store);
    app.mount("#app");

    loadMessages(vi);
    locale("vi");

    hideLoading();
})(createApp(App, {}));

